import React from 'react'
import PropTypes from 'prop-types'

import { minLength, maxLength, isAlphanumeric } from 'Pods/Shared/Rules/Rules'

const titleLimits = {
  min: 3,
  max: 80,
}

const defaultState = {
  isActive: false,
  name: '',
  error: null,
  inputErrorClass: '',
}

class SaveTemplateAction extends React.Component {
  constructor() {
    super()

    this.state = defaultState

    this.toggleSaving = this.toggleSaving.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  onSubmit(e) {
    e.preventDefault()

    if (this.props.templateNames.includes(this.state.name)) {
      return App.events.publish('app:notification:flash:error', 'Template with this name already exists.')
    }

    this.props.saveTemplate(this.state.name)
    this.setState(defaultState)
  }

  onCancel(e) {
    e.preventDefault()

    this.setState(defaultState)
  }

  handleInputChange(e) {
    e.preventDefault()

    const errorsInfo = this.hasErrors(e.target.value)
    const inputErrorClass = errorsInfo.hasError ? 'is-invalid' : ''

    this.setState({ name: e.target.value, error: errorsInfo.error, inputErrorClass })
  }

  hasErrors(value) {
    const textTooShort = minLength(titleLimits.min)(value)
    const textTooLong = maxLength(titleLimits.max)(value)
    const wrongSymbols = isAlphanumeric(value)

    if (textTooShort) {
      return ({
        hasError: textTooShort,
        error: textTooShort && textTooShort('Title'),
      })
    } if (wrongSymbols) {
      return ({
        hasError: wrongSymbols,
        error: wrongSymbols && wrongSymbols('Title'),
      })
    } if (textTooLong) {
      return ({
        hasError: textTooLong,
        error: textTooLong && textTooLong('Title'),
      })
    }
    return ({
      hasError: false,
      error: '',
    })
  }

  toggleSaving() {
    if (this.props.activeTemplateId === '') {
      this.setState({ isActive: !this.state.isActive })
    } else {
      this.props.editTemplate()
    }
  }

  renderInlineForm() {
    const error = <div className="error-message--tooltip">{this.state.error}</div>

    return (
      <div className={`inline-edit ${this.state.isActive ? 'is-active' : ''}`}>
        <form onSubmit={this.onSubmit}>
          <div className="form-group form-group-grey">
            {this.state.error && error}
            <input
              type="text"
              placeholder="Template name"
              value={this.state.name}
              onChange={(e) => this.handleInputChange(e)}
              className={`form-control form-control-grey ${this.state.inputErrorClass}`}
            />
          </div>

          <div className="row">
            <div className="col-6">
              <button
                type="button"
                onClick={this.onCancel}
                className="btn btn-fat btn-outline-default btn-block"
              >
                Cancel
              </button>
            </div>
            <div className="col-6">
              <button
                type="submit"
                className="btn btn-fat btn-primary btn-block"
                disabled={this.state.inputErrorClass !== '' || this.state.name.length === 0}
              >
                Save template
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  }

  render() {
    return (
      <span className="template-actions__save-template">
        {this.state.isActive ? (
          this.renderInlineForm()
        ) : (
          <button onClick={this.toggleSaving} className="btn btn-fat btn-outline-default btn-white btn-save-template">
            {this.props.activeTemplateId === '' ? 'Save as template' : 'Update template'}
          </button>
        )}
      </span>
    )
  }
}

SaveTemplateAction.propTypes = {
  saveTemplate: PropTypes.func.isRequired,
  editTemplate: PropTypes.func.isRequired,
  templateNames: PropTypes.array.isRequired,
  activeTemplateId: PropTypes.string.isRequired,
}

export default SaveTemplateAction
